import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useStock } from '../StockContext'; 
import Sidebar from '../partials/Sidebar';
import Header from '../partials/Header';
import DashboardCard01 from '../partials/dashboard/DashboardCard01';
import DashboardCard02 from '../partials/dashboard/DashboardCard02';
import DashboardCard03 from '../partials/dashboard/DashboardCard03';
import DashboardCard04 from '../partials/dashboard/DashboardCard04';
import DashboardCard05 from '../partials/dashboard/DashboardCard05';
import DashboardCard06 from '../partials/dashboard/DashboardCard06';
import DashboardCard07 from '../partials/dashboard/DashboardCard07';
import DashboardCard08 from '../partials/dashboard/DashboardCard08';
import DashboardCard09 from '../partials/dashboard/DashboardCard09';
import DashboardCard10 from '../partials/dashboard/DashboardCard10';
import DashboardCard11 from '../partials/dashboard/DashboardCard11';
import FintechCard14 from '../partials/fintech/FintechCard14';
import GlobeComponent from '../partials/Globe';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-red-50 dark:bg-gray-800 p-4 rounded-lg">
          <p className="text-red-500 dark:text-red-400 text-sm">Kunne ikke hente data</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function Dashboard() {
  const { stockSelected1, setStockSelected1 } = useStock();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Same data fetching approach as in DashboardCard08
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyData = async () => {
      if (!stockSelected1?.symbol) {
        console.error('No stockSymbol provided');
        setLoading(false);
        return;
      }
      try {
        const response = await axios.get(`https://investorverden.onrender.com/api/company?q=${stockSelected1.symbol}`);
        console.log('API response:', response.data);
        if (response.data) {
          setCompanyData(response.data);
        } else {
          console.error('No company data found');
          setCompanyData(null);
        }
      } catch (error) {
        console.error('Error fetching company data:', error);
      }
      setLoading(false);
    };

    fetchCompanyData();
  }, [stockSelected1]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex h-[100dvh] overflow-hidden">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        <Header
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          onStockSelect={setStockSelected1}
        />
        <main className="grow">
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="grid grid-cols-12 gap-6">
              {stockSelected1 ? (
                <>
                  <ErrorBoundary>
                    <DashboardCard01 selectedStock={stockSelected1} />
                  </ErrorBoundary>
                  <ErrorBoundary>
                    <DashboardCard02 stockSymbol={stockSelected1.symbol} />
                  </ErrorBoundary>
                  <ErrorBoundary>
                    <DashboardCard03
                      stockSymbol={stockSelected1.symbol}
                      MarketCapitalization={stockSelected1.marketCap}
                      EPS={stockSelected1.epsTrailingTwelveMonths}
                      SharesOutstanding={stockSelected1.sharesOutstanding}
                      TrailingPE={stockSelected1.trailingPE}
                      ForwardPE={stockSelected1.forwardPE}
                    />
                  </ErrorBoundary>
                  <ErrorBoundary>
                    <DashboardCard04 stockSymbol={stockSelected1.symbol} />
                  </ErrorBoundary>
                  <ErrorBoundary>
                    <DashboardCard05 stockSymbol={stockSelected1.symbol} />
                  </ErrorBoundary>
                  <ErrorBoundary>
                    <DashboardCard06 stockSymbol={stockSelected1.symbol} />
                  </ErrorBoundary>
                  <ErrorBoundary>
                    <DashboardCard07 stockSymbol={stockSelected1.symbol} />
                  </ErrorBoundary>
                  <ErrorBoundary>
                    <DashboardCard08 stockSymbol={stockSelected1.symbol} />
                  </ErrorBoundary>
                  <ErrorBoundary>
                    <DashboardCard09 stockSymbol={stockSelected1.symbol} />
                  </ErrorBoundary>
                  <ErrorBoundary>
                    <DashboardCard10 stockSymbol={stockSelected1.symbol} />   
                  </ErrorBoundary>

                  <br />
                  <br />
                  <br />
                  <br />
                </>
              ) : (
                <div className="col-span-12 flex justify-center items-center h-screen">
                  <div className="w-full h-full flex justify-center items-center">
                    <GlobeComponent />
                  </div>
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

Dashboard.propTypes = {
  stockSelected1: PropTypes.shape({
    symbol: PropTypes.string.isRequired,
  }),
};

export default Dashboard;